import { CONSTANTS } from '@/constants';
import { mergeAPIError } from '@/utils/errors';
import { request } from '@/utils/request';

export interface PaymentPreview {
  estimatedCost: string;
  price: string;
  discountPercentage: string;
  minQuantityToDiscount: number;
}

export async function getPaymentPreview(
  quantity: number,
  signal?: AbortSignal,
) {
  try {
    const res = await request(
      `${CONSTANTS.BASE_URL}/api/world-coin-chest-smasher/extra-eggs/payment/preview`,
      {
        method: 'POST',
        body: JSON.stringify({
          quantity: quantity,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
        signal,
      },
    );

    if (!res.ok) {
      const msg = await res
        .json()
        .then((e) => mergeAPIError(e))
        .catch((e) => e.message ?? res.statusText);
      throw new Error(`Failed with status ${res.status} :${msg}`);
    }

    const data: {
      data: PaymentPreview;
    } = await res.json();

    return data.data;
  } catch (error) {
    const message = mergeAPIError(error);

    throw new Error(message);
  }
}
